//@flow
export const bigMargin = 24;
export const defaultMargin = 12;
export const smallMargin = 6;
export const hugeButtonsSeparatorSize = 3;